import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderWrapper, HeaderContainer, HeaderLogo, HeaderActions, HeaderCallButton, HeaderPhoneText } from './styles/components';
import { PhoneNumbers } from "../data";
import { getCurrentPromoCode } from "../../utils/promoCodeUtils";


export default function HeaderNew() {
  const location = useLocation();
  const [isSticky, setIsSticky] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const isEnrollmentPage = location.pathname.startsWith('/v2/enrollment');

  useEffect(() => {
    if (isEnrollmentPage) { setIsSticky(true); return; }
    const handleScroll = () => {
      if (window.scrollY > 50) { setIsSticky(true); } 
      else { setIsSticky(false); }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isEnrollmentPage]);

  useEffect(() => {
    const pathPromo = location.pathname.substring(1);
    // Use path promo only if it exists in PhoneNumbers, otherwise use default
    setPromoCode(PhoneNumbers[pathPromo] ? pathPromo : getCurrentPromoCode(location.pathname));
  }, [location.pathname])

  return (
    <HeaderWrapper as="header" isSticky={isSticky}>
      <HeaderContainer>
        <HeaderLogo
          src={isSticky ? "/images/constenewImg/logo-constellation-lightmode.svg" : "/images/constenewImg/logo-constellation.svg"}
          alt="Constellation" 
        />
      </HeaderContainer>
      <HeaderActions>
        <HeaderCallButton
          variant="outlined"
          onClick={() => window.location.href = 'tel:(877) 352-3194'}
          isSticky={isSticky}
        >
          Call us now
        </HeaderCallButton>
        <HeaderPhoneText isSticky={isSticky}>
          {PhoneNumbers[promoCode] }
        </HeaderPhoneText>
      </HeaderActions>
    </HeaderWrapper>
  );
}